import { get, post, del } from '@elementary/common-ui/utils/http';
import { ScimConfig, CreateScimRequest, CreateScimResponse } from './types';

const API_BASE = import.meta.env.VITE_API_BASE_URL;

export const fetchScimConfig = (): Promise<ScimConfig | null> =>
  get(`${API_BASE}/account/scim/config`);

export const createScimConfig = (
  data: CreateScimRequest,
): Promise<CreateScimResponse> =>
  post(`${API_BASE}/account/scim/config`, {
    source: data.source,
  });

export const deleteScimConfig = (): Promise<void> =>
  del(`${API_BASE}/account/scim/config`);
